/* Dive Centre Bondi — inline review tiles on course pages.
   - Tracks every product handle the visitor opens (localStorage)
   - On course-listing pages, fetches the latest Okendo review for each recently-viewed
     product and injects it into the static review tiles
   - Gracefully falls back to the tile's hardcoded quote/author/rating if Okendo has no data
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'bondi_dive_recently_viewed';
  var MAX_RECENT = 12;
  var SUBSCRIBER_ID = (window.__bondiDiveOkendoSubscriberId) || '41454ce7-a346-41a4-ae2d-0c459e8681c5';
  var OKE_ENDPOINT = 'https://api.okendo.io/v1/stores/' + SUBSCRIBER_ID + '/products/';

  // ---------- Recently-viewed tracking ----------
  function loadRecent() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveRecent(arr) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(arr.slice(0, MAX_RECENT))); } catch (e) {}
  }
  function pushHandle(handle) {
    if (!handle) return;
    var recent = loadRecent().filter(function (h) { return h !== handle; });
    recent.unshift(handle);
    saveRecent(recent);
  }
  function trackThisPage() {
    // PDP — /products/{handle}
    var pm = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (pm) { pushHandle(pm[1]); return; }
    // Course detail — /pages/{course-handle} where dive-course-detail emits a meta tag
    var courseMeta = document.querySelector('meta[name="dive-course-product-handle"]');
    if (courseMeta && courseMeta.content) { pushHandle(courseMeta.content); }
  }

  // ---------- Okendo fetcher ----------
  function getProductIdFromHandle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.product ? j.product.id : null; })
      .catch(function () { return null; });
  }
  function fetchLatestReview(handle) {
    return getProductIdFromHandle(handle).then(function (productId) {
      if (!productId) return null;
      return fetch(OKE_ENDPOINT + productId + '/reviews?limit=4')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.reviews || !j.reviews.length) return null;
          // Prefer 4★+ reviews if any; otherwise just take the latest
          var pick = j.reviews.filter(function (r) { return (r.rating || 0) >= 4; })[0] || j.reviews[0];
          var quote = pick.body || pick.content || pick.text || pick.reviewBody || '';
          var title = pick.title || '';
          var author = '';
          if (pick.reviewer && pick.reviewer.displayName) author = pick.reviewer.displayName;
          else if (pick.author) author = pick.author;
          else if (pick.reviewer && pick.reviewer.name) author = pick.reviewer.name;
          var rating = parseFloat(pick.rating || pick.starRating || pick.score || 5);
          if (isNaN(rating) || rating < 1 || rating > 5) rating = 5;
          var thumb = pick.productImageUrl || '';
          var verified = !!(pick.reviewer && pick.reviewer.isVerified);
          return { quote: quote, title: title, author: author, rating: rating, thumb: thumb, verified: verified, product_handle: handle };
        })
        .catch(function () { return null; });
    });
  }

  // ---------- Tile updates ----------
  function setStars(el, rating) {
    if (!el) return;
    var full = Math.floor(rating);
    var half = rating - full >= 0.5;
    var stars = '';
    for (var i = 0; i < full; i++) stars += '★';
    if (half) stars += '½';
    for (var j = full + (half ? 1 : 0); j < 5; j++) stars += '☆';
    el.textContent = stars;
  }
  function applyReview(tile, review) {
    if (!review) return;
    var q = tile.querySelector('[data-review-quote]');
    var a = tile.querySelector('[data-review-author]');
    var s = tile.querySelector('[data-review-stars]');
    var thumbEl = tile.querySelector('img');
    if (q && review.quote) {
      // If Okendo returns a title, prepend it as a bold lead-in
      var html = '';
      if (review.title) html += '<strong style="display:block;margin:0 0 6px;">' + escapeHtml(review.title) + '</strong>';
      html += escapeHtml(review.quote);
      q.innerHTML = html;
    }
    if (a) {
      var authorText = review.author || '';
      if (review.verified) authorText += ' · Verified';
      a.textContent = authorText;
    }
    if (s && review.rating) setStars(s, review.rating);
    // When live review has a product image, replace the static fallback so the
    // photo matches the actual reviewed product
    if (review.thumb) {
      if (thumbEl) {
        thumbEl.setAttribute('src', review.thumb);
      } else {
        var thumbCls = tile.classList.contains('dcl__tile-review') ? 'dcl__tile-review-thumb' : 'dcc__tile-review-thumb';
        var span = document.createElement('span');
        span.className = thumbCls;
        span.innerHTML = '<img src="' + review.thumb + '" alt="">';
        tile.insertBefore(span, tile.firstChild);
      }
    }
    tile.setAttribute('data-review-live', 'true');
    if (review.product_handle) tile.setAttribute('data-review-product-handle', review.product_handle);
  }
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }
  function pickHandleForTile(tile, recentHandles, usedSet) {
    // 1) Explicit product_handle on the tile wins
    var explicit = tile.getAttribute('data-product-handle');
    if (explicit && !usedSet.has(explicit)) { usedSet.add(explicit); return explicit; }
    // 2) Next unused recently-viewed handle
    for (var i = 0; i < recentHandles.length; i++) {
      if (!usedSet.has(recentHandles[i])) { usedSet.add(recentHandles[i]); return recentHandles[i]; }
    }
    return null;
  }
  function hydrate() {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('[data-review-tile]'));
    if (!tiles.length) return;
    var recent = loadRecent();
    var used = new Set();
    tiles.forEach(function (tile) {
      var handle = pickHandleForTile(tile, recent, used);
      if (!handle) return; // Tile keeps its fallback content
      fetchLatestReview(handle).then(function (review) {
        if (review && review.quote) applyReview(tile, review);
      });
    });
  }

  // ---------- Init ----------
  trackThisPage();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
